import { getJsonOrError, getBlobOrError } from '../utils/apiHelpers';

export class ProjectApi {
  constructor(DjUrls, csrfToken) {
    this.DjUrls = DjUrls;
    this.csrfToken = csrfToken;
  }
  async getProjectsList() {
    const url = this.DjUrls['normair:project_list']();
    const resp = await fetch(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': this.csrfToken,
      },
    });
    return await getJsonOrError(resp);
  }
  async getProject(projectId) {
    const url = this.DjUrls['normair:project_details']({
      project_id: projectId,
    });
    const resp = await fetch(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': this.csrfToken,
      },
    });
    return await getJsonOrError(resp);
  }
  async addProject(body) {
    const url = this.DjUrls['normair:project_list']();
    const resp = await fetch(url, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': this.csrfToken,
      },
      body: JSON.stringify(body),
    });
    return await getJsonOrError(resp);
  }
  async deleteProject(projectId) {
    const url = this.DjUrls['normair:project_details']({
      project_id: projectId,
    });
    const resp = await fetch(url, {
      method: 'delete',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': this.csrfToken,
      },
    });
    if (300 > resp.status && resp.status >= 200) {
      return true;
    } else {
      return false;
    }
  }
}
export class StepsApi {
  constructor(DjUrls, csrfToken) {
    this.DjUrls = DjUrls;
    this.csrfToken = csrfToken;
  }
  async importData(projectId, formData, stepsToReset) {
    const url =
      this.DjUrls['normair:data_import']({ project_id: projectId }) +
      (stepsToReset ? `?steps-to-reset=${stepsToReset}` : '');
    const resp = await fetch(url, {
      method: 'POST',
      headers: {
        'X-CSRFToken': this.csrfToken,
      },
      body: formData,
    });
    return await getJsonOrError(resp);
  }
  async validateColumnsInit(projectId) {
    const url = this.DjUrls['normair:column_validation']({
      project_id: projectId,
    });
    const resp = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': this.csrfToken,
      },
    });
    return await getJsonOrError(resp);
  }
  async validateAdditionalColumn(projectId, additionalColumn) {
    const url = this.DjUrls['normair:additional_column_validation']({
      project_id: projectId,
    });
    const resp = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': this.csrfToken,
      },
      body: JSON.stringify(additionalColumn),
    });
    // TODO: some react library for handling requests
    if (resp.status == '409') {
      return {
        status: 'wrong-name',
      };
    }
    return await getJsonOrError(resp);
  }
  async validateColumnsConfirm(projectId) {
    const url = this.DjUrls['normair:column_validation_confirm']({
      project_id: projectId,
    });
    const resp = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': this.csrfToken,
      },
    });
    return await getJsonOrError(resp);
  }
  async importSummaryInit(projectId) {
    const url = this.DjUrls['normair:import_summary']({
      project_id: projectId,
    });
    const resp = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': this.csrfToken,
      },
    });
    return await getJsonOrError(resp);
  }
  async importSummaryConfirm(projectId) {
    const url = this.DjUrls['normair:import_summary_confirm']({
      project_id: projectId,
    });
    const resp = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRFToken': this.csrfToken,
      },
    });
    return await getJsonOrError(resp);
  }
  // TODO: implement
  importSummaryDownload(projectId) {
    return this.DjUrls['normair:import_summary_download']({
      project_id: projectId,
    });
  }
  async visualization(
    projectId,
    stepName,
    visualizationType,
    fileHash,
    formData,
  ) {
    const url = this.DjUrls['normair:visualization']({
      project_id: projectId,
      step_name: stepName,
      visualization_type: visualizationType,
    });
    const params = new URLSearchParams(formData).toString();

    // fileHash is for the purpose of resetting the browser / backend
    // cache if user changes the file
    const resp = await fetch(url + `?filehash=${fileHash}&${params}`, {
      method: 'GET',
      headers: {
        'X-CSRFToken': this.csrfToken,
      },
    });
    if (visualizationType != 'evaluationmetrics') {
      return await getBlobOrError(resp);
    } else {
      // evaluation metrics return Json response, because
      // the visualization for them is table data
      return await getJsonOrError(resp);
    }
  }
  async modelTraining(projectId, formData) {
    const url = this.DjUrls['normair:modeltraining']({ project_id: projectId });

    const resp = await fetch(url, {
      method: 'POST',
      headers: {
        'X-CSRFToken': this.csrfToken,
      },
      body: formData,
    });
    return await getJsonOrError(resp);
  }
  async normalization(projectId, formData) {
    const url = this.DjUrls['normair:normalization']({ project_id: projectId });

    const resp = await fetch(url, {
      method: 'POST',
      headers: {
        'X-CSRFToken': this.csrfToken,
      },
      body: formData,
    });
    return await getJsonOrError(resp);
  }
}
